export default __webpack_public_path__ + "static/media/logo.a75f55bc.svg";